"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

function sortByEditAt(list) {
  var cloned = lodash_1.default.clone(list);
  cloned.sort(function (a, b) {
    var aItem = a._item;
    var bItem = b._item;

    if (aItem === null && bItem === null) {
      return 0;
    }

    if (aItem === null) {
      return -1;
    }

    if (bItem === null) {
      return 1;
    }

    if (!lodash_1.default.has(aItem, 'edit_at.seconds') || !lodash_1.default.has(aItem, 'edit_at.nanoseconds') || !lodash_1.default.has(bItem, 'edit_at.seconds') || !lodash_1.default.has(bItem, 'edit_at.nanoseconds')) {
      return -1;
    }

    var aItemEditAt = aItem.edit_at;
    var aItemEditAtTs = aItemEditAt.seconds * 1000 + aItemEditAt.nanoseconds / 1000000;
    var bItemEditAt = bItem.edit_at;
    var bItemEditAtTs = bItemEditAt.seconds * 1000 + bItemEditAt.nanoseconds / 1000000;
    return bItemEditAtTs - aItemEditAtTs;
  });
  return cloned;
}

exports.sortByEditAt = sortByEditAt;